<template>
  <!-- 发票申请记录 -->
  <div class="invoiceRequestRecord">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <!-- <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportData"
          v-if="buttonVisibility.export"
          >导出数据</el-button
        > -->
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单号"
          v-model="searchForm.content"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          v-if="buttonVisibility.search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="OrderNo"
        show-overflow-tooltip
        label="订单号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="TitleName"
        show-overflow-tooltip
        label="抬头名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="TaxNumber"
        show-overflow-tooltip
        label="税号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="InvoiceType"
        show-overflow-tooltip
        label="发票"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Email"
        show-overflow-tooltip
        label="邮箱"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="AddTime"
        show-overflow-tooltip
        label="申请时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Applicant"
        show-overflow-tooltip
        label="申请人"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Status"
        show-overflow-tooltip
        label="状态"
      > 
        <template slot-scope="scope">
          <span>{{ formatStatus(scope.row.Status) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            <el-button
             v-if="buttonVisibility.confirmInvoice && scope.row.Status != 2"
              type="success"
              style="padding: 2px 3px"
              plain
              @click="confirmInvoice(scope.row)"
              >发票确认
            </el-button>
            </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "invoiceRequestRecord",
  data() {
    return {
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      //支付方式 开始时间 截至时间 单号
      searchForm: {
        start: "",
        end: "",
        content: "",
      },
      /**表格数据 */
      //订单号	抬头名称	税号	发票	邮箱	申请时间	申请人
      tableData: [
        {
          OrderNo: "",
          TitleName: "",
          TaxNumber: "",
          InvoiceType: "",
          Email: "",
          AddTime: "",
          Applicant: "",
        },
      ],
    };
  },
  components: {},
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['发票申请记录'] || [] ;
      return {
        export: buttonsLimit.includes('导出数据'),
        search: buttonsLimit.includes('搜索'),
        confirmInvoice: buttonsLimit.includes('发票确认'),
      }
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        searchVal: this.searchForm.content,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        url: "Order/InvoiceRequestRecord",
        method: "post",
        data: data,
      })
        .then((res) => {
          console.log('res',res);
          this.tableData = [];
          if (res.success == true) {
            this.tableData = res.dataList;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    // 文字格式化状态
    formatStatus(Status) {
      const statusMap = {
        '0': '拒绝',
        '1': '申请', 
        '2': '已开', 
      };
    return statusMap[Status] || Status;
    },
    // 发票确认
    confirmInvoice(row) {

      this.$confirm("是否确认发票？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          id: row.Id,
          OrderNo: row.OrderNo,
          status: 2,
        }
        this.$request({
          url: "Order/InvoiceRequestConfirm",
          method: "post",
          data: data,
        })
          .then((res) => {
            console.log('发票确认', res);
            if (res.success) {
              this.$message({
                message: "发票确认成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
      })

    },
    exportData() {
      // let startDate = this.searchForm.start
      // let endDate = this.searchForm.end
      // let payType = this.searchForm.status
      // let txtStrWhere = this.searchForm.content
      // let userId = window.localStorage.getItem('userId')
      // let entId = window.localStorage.getItem('entId')
      // window.location = this.baseUrl + "ToExcel/ToExcePayOrderList?startDate=" + startDate + "&endDate=" + endDate + "&payType=" + payType + "&strWhere=" + txtStrWhere + "&userId=" + userId + "&entId=" + entId

      let data = {
        type: "OrderPayInquire",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        searchVal: this.searchForm.content,
        // payType: this.searchForm.status,
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_OrderPay";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=在线支付订单";
    },
  },
};
</script>

<style scoped>
.invoiceRequestRecord {
  width: 100%;
  height: 100%;
}
</style>
